"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelLeaseValidator = void 0;
const ts_types_1 = require("@waves/ts-types");
const validators_1 = require("./validators");
const cancelLeaseScheme = {
    type: validators_1.isEq(ts_types_1.TRANSACTION_TYPE.CANCEL_LEASE),
    senderPublicKey: validators_1.isPublicKey,
    version: validators_1.orEq([undefined, 2, 3]),
    leaseId: validators_1.isAssetId,
    chainId: validators_1.isNumber,
    fee: validators_1.isNumberLike,
    timestamp: validators_1.isNumber,
    proofs: validators_1.ifElse(validators_1.isArray, validators_1.defaultValue(true), validators_1.orEq([undefined])),
};
exports.cancelLeaseValidator = validators_1.validateByShema(cancelLeaseScheme, validators_1.getError);
//# sourceMappingURL=cancel-lease.js.map